var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"frame-payment yasno\"> <div class=\"container\"> <div class=\"payment\"> <div class=\"main-content row\" ct-spinner=\"pay.data.preLoader\"> <div ng-hide=\"pay.data.preLoader && pay.data.load == 'stepOne' || pay.innerState =='3dSecure'\"> <payment-check></payment-check> <payment-confirm style=\"clear:both; display:block\"></payment-confirm> </div> <div ng-show=\"pay.innerState =='3dSecure'\" class=\"secure3d\"> <secure3d></secure3d> </div> </div> </div> </div> </div>";
ngModule.run(["$templateCache",function(c){c.put("yasno/templates/index.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/yasno/templates/index.html
 ** module id = 611
 ** module chunks = 1
 **/